<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [isPrimaryButtonHidden]="true"
    secondaryButtonLabel="Cancel" (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex"
    [modalClass]="modalClass" [buttonTemplate]="buttonTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
    <res-export [ngClass]="exportVolumesAllowed ? 'export-to-relativity-modal-class' : ''"
        [selectedExportStream]="selectedExportStream" [isExportToRelativity]="exportVolumesAllowed"
        [automationId]="modalAutomationId" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"></res-export>
    <ng-template #buttonTemplate>
        <div>
            <button [hidden]="exportVolumesAllowed" type="button"
                [attr.data-automation-id]="modalAutomationId + '-save-empty-export-button'" class="secondary-button"
                (click)="saveEmptyExport()"
                [title]="[checkForErrors() ? 'Errors found. Click to highlight all.': (exportNameNotValidated()? '' : 'No errors found.')]"
                [disabled]="saveEmptyExportDisabled()">
                <i class="fa fa-save color-blue-01"></i>Save Empty Export
            </button>
            <i class="badge-save-export button-badge"
                [ngClass]="[checkForErrors() ? 'fa fa-exclamation-circle': 'fa fa-check-circle']"
                [hidden]="saveEmptyExportDisabled() || exportNameNotValidated() || exportVolumesAllowed"
                [attr.data-automation-id]="modalAutomationId + '-save-empty-export-badge'"></i>
            <button [hidden]="exportVolumesAllowed" type="button"
                [attr.data-automation-id]="modalAutomationId + '-stage-export-button'" class="secondary-button"
                (click)="stageExport()"
                [title]="[checkForErrors() ? 'Errors found. Click to highlight all.': (exportNameNotValidated()? '' : 'No errors found.')]">
                Stage Export
            </button>
            <i class="badge-stage-export button-badge" [hidden]="exportNameNotValidated() || exportVolumesAllowed"
                [ngClass]="[checkForErrors() ? 'fa fa-exclamation-circle': 'fa fa-check-circle']"
                [attr.data-automation-id]="modalAutomationId + '-stage-export-badge'"></i>
            <button type="button" [attr.data-automation-id]="modalAutomationId + '-run-export-button'"
                class="primary-button" (click)="runExport()"
                [title]="[checkForErrors() ? 'Errors found. Click to highlight all.': (exportNameNotValidated()? '' : 'No errors found.')]">
                <i class="fa fa-play"></i>Run Export
            </button>
            <i class="badge-run-export button-badge" [hidden]="exportNameNotValidated()"
                [ngClass]="[checkForErrors() ? 'fa fa-exclamation-circle': 'fa fa-check-circle']"
                [attr.data-automation-id]="modalAutomationId + '-run-export-badge'"></i>
        </div>
    </ng-template>
</res-base-modal>